export * from "ce/pages/common/WorkflowSearchItem";
import { default as CE_WorkflowSearchItem } from "ce/pages/common/WorkflowSearchItem";
export default CE_WorkflowSearchItem;
